<template>
  <!-- 机构会员列表 -->
  <div class="agencyMembers">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['客户管理', $route.meta.title]"
    >
      <template slot="controls"> </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">客户状态：</label>
        <el-select
          v-model="searchForm.status"
          placeholder="客户状态"
          style="width: 100px; margin-right: 5px"
        >
          <el-option
            v-for="(item, index) in itemList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-input
          v-model="searchForm.name"
          style="width: 200px; margin-right: 5px"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="search"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column
        prop="EntName"
        align="center"
        show-overflow-tooltip
        label="机构名称"
      >
      </el-table-column>
      <el-table-column
        prop="UserName"
        align="center"
        show-overflow-tooltip
        label="登陆名"
      >
      </el-table-column>
      <el-table-column
        prop="Name"
        label="会员姓名"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="TelPhone"
        show-overflow-tooltip
        label="联系方式"
      >
      </el-table-column>
      <el-table-column
        prop="BusinessName"
        label="单位名称"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="ErpCcode"
        label="ERP编号"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="PriceLevel"
        label="客户级别"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="Integral"
        label="会员积分"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="Balance"
        label="会员余额"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="Status"
        label="审核状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag type="danger" v-if="scope.row.Status == '1'">未启用</el-tag>
          <el-tag type="success" v-if="scope.row.Status == '2'">已启用</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="AddTime"
        label="申请日期"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column label="操作" align="center" width="160">
        <template slot-scope="scope">
          <el-button
            type="primary"
            plain
            style="padding: 2px 3px"
            @click="seeInfo(scope.row)"
            >详情</el-button
          >
          <el-button
            type="danger"
            plain
            style="padding: 2px 3px"
            v-if="scope.row.Status == 2"
            @click="changeStatus(scope.row, 1)"
            >禁用</el-button
          >
          <el-button
            type="success"
            plain
            style="padding: 2px 3px"
            v-if="scope.row.Status == 1"
            @click="changeStatus(scope.row, 2)"
            >启用</el-button
          >
          <el-button
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="userPrice(scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>

    <!-- 修改价格级别 -->
    <el-dialog
      title="机构会员"
      :visible.sync="priceDrawer"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      width="70%"
    >
      <el-scrollbar style="height: 300px">
        <div class="drawer-form-wrap">
          <el-form
            :model="priceForm"
            label-position="rigth"
            label-width="100px"
            :rules="priceFormRule"
            ref="priceForm"
          >
            <div class="form-item-wrap">
              <el-form-item label="价格级别" prop="level">
                <el-select
                  v-model="priceForm.level"
                  placeholder="价格级别"
                  style="width: 200px"
                >
                  <el-option
                    v-for="(item, index) in levelList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="form-item-wrap">
              <el-form-item label="ERP编号" prop="erpCode">
                <el-input
                  v-model="priceForm.erpCode"
                  clearable
                  style="width: 200px"
                ></el-input>
              </el-form-item>
            </div>
            <div class="form-item-wrap">
              <el-form-item label="资格证书">
                <el-table
                  :data="seniorityList"
                  tooltip-effect="dark"
                  style="
                    width: 700px;
                    border: 1px solid #ebeef5;
                    border-bottom: none;
                  "
                >
                  <el-table-column label="序号" align="center" width="50">
                    <template slot-scope="scope">
                      <span>{{ scope.$index + 1 }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    show-overflow-tooltip
                    prop="name"
                    label="名称"
                  >
                  </el-table-column>
                  <el-table-column
                    align="center"
                    show-overflow-tooltip
                    prop="img"
                    label="证书"
                  >
                    <template slot-scope="scope">
                      <img-view
                        :imgList="[{ url: scope.row.img, id: 0 }]"
                      ></img-view>
                    </template>
                  </el-table-column>
                  <el-table-column prop="validity" label="效期" align="center">
                  </el-table-column>
                </el-table>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button type="info" @click="clearForm">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: "agencyMembers",
  data() {
    return {
      /**表格数据 */
      tableData: [],
      itemList: [
        {
          value: "1",
          label: "未启用",
        },
        {
          value: "2",
          label: "已启用",
        },
      ],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**搜索表单 */
      searchForm: {
        status: "2",
        name: "",
      },
      // 价格级别相关
      priceDrawer: false,
      priceForm: {
        id: "",
        level: "",
        erpCode: "",
      },
      priceFormRule: {
        level: [mustFill],
        erpCode: [mustFill],
      },
      levelList: [],
      seniorityList: [],
    };
  },
  components: {},
  mounted() {
    this.getTableData();
  },
  methods: {
    search() {
      this.getTableData(1);
    },
    // 获取表格信息
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        type: "GetUserInfo",
        status: this.searchForm.status,
        searchValue: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      this.$request({
        method: "post",
        url: "Member/HTGetUserEntDoc",
        data: data,
      }).then((res) => {
        console.log(res);
        this.tableData = [];
        if (res.success) {
          this.tableData = res.list;
          this.allPage = res.list.length;
        }
      });
    },
    // 获取会员价格等级
    userPrice(row) {
      this.getSeniority(row);
      let data = {
        entId: row.EntId,
      };
      this.clearForm();
      this.priceForm.id = row.KeyId;
      this.priceForm.level = row.PriceLevel || "";
      this.priceForm.erpCode = row.ErpCcode || "";
      this.$request({
        method: "post",
        url: "Member/MemberPriceType",
        data: data,
      }).then((res) => {
        if (res.success) {
          this.levelList = res.list.map((item) => ({
            label: item.PriceLevel,
            value: item.PriceLevel,
          }));
          this.priceDrawer = true;
        } else {
          this.$message({
            message: res.message,
            type: "error",
          });
        }
      });
    },
    // 获取资质列表
    getSeniority(row) {
      let data = {
        userId: row.UserId,
      };
      this.$request({
        method: "post",
        url: "Member/GetMemberMaterial",
        data: data,
      }).then((res) => {
        if (res.success) {
          this.seniorityList = res.list.map((item) => ({
            name: item.materialName,
            img: item.materialUrl,
            validity: item.lastmodifytime,
          }));
        } else {
          this.$message({
            message: res.message,
            type: "error",
          });
        }
      });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    seeInfo(row) {
      let prams = encodeURIComponent(JSON.stringify({ id: row.UserId }));
      let path = "memInfo";
      this.$router.push({
        path: path,
        query: {
          prams: prams,
        },
      });
    },
    /**修改客户状态 */
    changeStatus(row, status) {
      let msg = "确定要执行操作吗?";
      let type = "info";
      if (status == 1) {
        msg = "确定禁用吗?";
        type = "warning";
      } else if (status == 2) {
        msg = "确定启用吗?";
        type = "success";
        if (!row.ErpCcode) {
          this.$message({
            message: "请先编辑ERP编号！",
            type: "warning ",
          });
          return;
        }
      }
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: type,
      })
        .then(() => {
          let data = {
            keyId: row.KeyId,
            status: status,
          };
          this.$request({
            method: "post",
            url: "Member/HTAuditUserEntDoc",
            data: data,
          }).then((res) => {
            if (res.success) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.getTableData();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    /**关闭drawer 清空表单信息 */
    clearForm() {
      for (let key in this.priceForm) {
        this.priceForm[key] = "";
      }
      this.priceDrawer = false;
    },
    // 提交表单
    submit() {
      this.$refs["priceForm"].validate((valid) => {
        if (valid) {
          let data = {
            keyId: this.priceForm.id,
            priceLevel: this.priceForm.level,
            erpCcode: this.priceForm.erpCode,
          };
          this.$request({
            method: "post",
            url: "Member/SaveMemberPriceType",
            data: data,
          })
            .then((res) => {
              if (res.success) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getTableData();
                this.clearForm();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        } else {
          this.$message({
            message: "请补全信息",
            type: "warning",
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.agencyMembers {
  width: 100%;
  height: 100%;
}
</style>
